import {
  IDefaultColorsConfiguration,
  IBackgroundColorConfiguration,
  IBorderColorConfiguration,
  IObjectColorConfiguration,
  IEnableConfiguration,
} from "../../../../domain/configuration";
import {
  PaintStyle,
  TextStyle,
} from "../../../../domain/drawing";
import {
  AbstractTextItem,
  IPaintable,
  instanceOfIPaintableOnEditing,
} from "../../../../domain/document/items";
import { AbstractTextObjectStyleReader } from "./AbstractTextObjectStyleReader";

export class ColorFixedTextObjectStyleReader extends AbstractTextObjectStyleReader<AbstractTextItem & IPaintable> {
  constructor(private readonly _configuration: IDefaultColorsConfiguration) {
    super();
  }

  protected readSpecifiedPaintStyle(source: AbstractTextItem & IPaintable, shouldInputFree: boolean): PaintStyle {
    return instanceOfIPaintableOnEditing(source)
      ? source.paintStyleOnEditing
      : source.paintStyle;
  }

  protected readBackgroundColorConfiguration(source: AbstractTextItem & IPaintable, shouldInputFree: boolean): IBackgroundColorConfiguration {
    return this.readObjectStyleConfiguration(source);
  }

  protected readBorderColorConfiguration(source: AbstractTextItem & IPaintable, shouldInputFree: boolean): IBorderColorConfiguration {
    return this.readObjectStyleConfiguration(source);
  }

  private readObjectStyleConfiguration(source: AbstractTextItem & IPaintable): IObjectColorConfiguration {
    return this._configuration.default;
  }

  public readTextStyle(source: AbstractTextItem & IPaintable, shouldInputFree: boolean, isFocused: boolean): TextStyle {
    return this.toTextStyle(source);
  }

  protected readForegroundDisplayConfiguration(): IEnableConfiguration {
    return null;
  }
}
